import type { Props as DeeplinkProps } from './Deeplink'
import Deeplink from './Deeplink'

export default Deeplink
export type { DeeplinkProps }
